import React from 'react';
import { Box, TextField, InputAdornment, Select, MenuItem } from '@mui/material';
import { Search } from '@mui/icons-material';

export const MenuSearchHeader = ({
  menus,
  selectedMenuId,
  onMenuChange,
  searchQuery,
  onSearchChange,
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        px: 3,
        pt: 3,
      }}
    >
      {/* Top row: Menu selector + Search */}
      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mb: 2 }}>
        {menus.length > 1 && (
          <Select
            value={selectedMenuId || ''}
            onChange={(e) => onMenuChange(e.target.value)}
            size="small"
            displayEmpty
            sx={{
              minWidth: 160,
              borderRadius: '14px',
              bgcolor: 'rgba(245, 245, 247, 0.8)',
              fontSize: '0.813rem',
              fontWeight: 600,
              '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.06)' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.10)' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#4527A0',
                borderWidth: 1.5,
              },
            }}
          >
            {menus.map((menu) => (
              <MenuItem key={menu.menu_id} value={menu.menu_id}>
                {menu.menu_name}
                {menu.is_primary_menu === 'yes' && ' ★'}
              </MenuItem>
            ))}
          </Select>
        )}

        {/* Search bar — full width */}
        <TextField
          placeholder="Search menu items..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          size="small"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: '#86868B', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '14px',
              bgcolor: 'rgba(245, 245, 247, 0.8)',
              fontSize: '0.813rem',
              height: 42,
              '& .MuiInputBase-input': { py: 1 },
              '& fieldset': { borderColor: 'rgba(0,0,0,0.06)' },
              '&:hover fieldset': { borderColor: 'rgba(0,0,0,0.10)' },
              '&.Mui-focused fieldset': {
                borderColor: '#4527A0',
                borderWidth: 1.5,
              },
            },
          }}
        />
      </Box>

      {/* Category chips — horizontally scrollable */}
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          overflowX: 'auto',
          pb: 2,
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
          flexShrink: 0,
        }}
      >
        {categories.map((cat) => {
          const isActive = selectedCategory === cat;
          return (
            <Box
              key={cat}
              onClick={() => onCategoryChange(cat)}
              sx={{
                px: 2,
                py: 0.85,
                minHeight: 36,
                display: 'inline-flex',
                alignItems: 'center',
                borderRadius: '28px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontSize: '0.78rem',
                fontWeight: 600,
                letterSpacing: '0.01em',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                bgcolor: isActive ? '#4527A0' : 'rgba(245, 245, 247, 0.9)',
                color: isActive ? '#FFFFFF' : '#1D1D1F',
                border: isActive ? 'none' : '1px solid rgba(0,0,0,0.06)',
                boxShadow: isActive ? '0 2px 8px rgba(69, 39, 160, 0.3)' : 'none',
                '&:hover': {
                  bgcolor: isActive ? '#311B92' : 'rgba(69, 39, 160, 0.06)',
                  borderColor: isActive ? 'transparent' : 'rgba(69, 39, 160, 0.15)',
                },
                '&:active': { transform: 'scale(0.96)' },
                userSelect: 'none',
              }}
            >
              {cat}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
